import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ToastComponent } from './shared/components/toast/toast.component';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  template: `
    <router-outlet></router-outlet>
    <app-toast></app-toast>
  `,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly theme = inject(ThemeService);
  private readonly router = inject(Router);
  private routerSub?: Subscription;

  ngOnInit(): void {
    this.routerSub = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e) => {
        const url = (e as NavigationEnd).urlAfterRedirects;
        // Public pages and onboarding → dark NOT allowed
        const isPublicPage =
          url === '/' ||
          url.startsWith('/login') ||
          url.startsWith('/register') ||
          url.startsWith('/pricing') ||
          url.startsWith('/landing') ||
          url.startsWith('/onboarding') ||
          url.startsWith('/forgot-password') ||
          url.startsWith('/reset-password') ||
          url.startsWith('/please-verify') ||
          url.startsWith('/verify-email');

        this.theme.setDarkAllowed(!isPublicPage);
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
}
